export const SCREEN_SIZE = {
  FULL: 1200,
  DESKTOP: 1024,
  TABLET: 768,
  MOBILE: 768,
};
